import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Comment } from '../entities/comment';

@Injectable({
  providedIn: 'root'
})
export class NoteService {

  constructor(private http: HttpClient) {}

  private baseUrl = environment.apiUrl + '/api/note/';
  basic: string | string[];

  getTrackComments(trackId: number): Observable<any> {
    return this.http.get(`${this.baseUrl}tracks/${ trackId }`, { responseType: 'text' });
  }
}
